"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _dashboard = require("@/api/dashboard");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  components: {
    echartsNew: _index.default
  },
  data: function data() {
    return {
      grid: {
        xl: 4,
        lg: 8,
        md: 12,
        sm: 6,
        xs: 24
      },
      nav_list: [{
        bgColor: '#EF9C20',
        icon: 'icon-yonghuguanli',
        title: '用户管理',
        url: '/user/index'
      }, {
        bgColor: '#1890FF',
        icon: 'icon-shangpinguanli',
        title: '商品管理',
        url: '/product/list'
      }, {
        bgColor: '#4BCAD5',
        icon: 'icon-shanghuguanli',
        title: '商户管理',
        url: '/merchant/list'
      }, {
        bgColor: '#A277FF',
        icon: 'icon-a-dingdanguanli1',
        title: '订单管理',
        url: '/order/list'
      }, {
        bgColor: '#1BBE6B',
        icon: 'icon-xitongshezhi',
        title: '系统设置',
        url: '/operation/setting'
      }, {
        bgColor: '#1890FF',
        icon: 'icon-fenxiaoshezhi',
        title: '分销设置',
        url: '/distribution/distributionconfig'
      }, {
        bgColor: '#A277FF',
        icon: 'icon-caiwuguanli',
        title: '财务管理',
        url: '/finance/statement'
      }, {
        bgColor: '#EF9C20',
        icon: 'icon-yihaotong',
        title: '一号通',
        url: '/operation/onePass/home'
      }, {
        bgColor: '#4BCAD5',
        icon: 'icon-qiandaopeizhi',
        title: '签到配置',
        url: '/marketing/sign/config'
      }],
      statisticData: [{
        title: '待审核商品数量',
        num: 0,
        path: '/product/list'
      }, {
        title: '待核销订单数量',
        num: 0,
        path: '/order/list'
      }, {
        title: '待发货订单数量',
        num: 0,
        path: '/order/list'
      }, {
        title: '在售商品数量',
        num: 0,
        path: '/product/list'
      }, {
        title: '待退款订单数量',
        num: 0,
        path: '/order/refund'
      }],
      optionData: {},
      applyNum: 0,
      style: {
        height: '250px'
      }
    };
  },
  computed: {
    //鉴权处理
    permList: function permList() {
      var arr = [];
      this.nav_list.forEach(function (item) {
        //if (this.checkPermi(item.perms)) {
        arr.push(item);
        //}
      });
      return arr;
    }
  },
  mounted: function mounted() {
    // this.getbusinessData();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    navigatorTo: function navigatorTo(path) {
      this.$router.push(path);
    }
  }
};